import api from '@/lib/api'

const defaultMe = () => ({
  user_id: -1, 
  name: '', email: '',
  reward_balance_cents: 0,
  rewards_beta: false,
  account: { 
    account_id: -1,
    account_name: ''
  } 
})

const state = () => ({
  acceptanceKeys: {
    user_id: '',
    acceptance_token: '',
  },

  badges: [],

  me: defaultMe(),

  recoveryMethods: [],

  settings_loaded: false,
  settings: {},

  // this way to handle booleans hurts my soul a little
  signedIn: null,

  unverifiedUser: '',

  w9: null,
})

const getters = {
  acceptanceKeys: state => state.acceptanceKeys,
  badges: state => state.badges,
  me: state => state.me,
  recoveryMethods: state => state.recoveryMethods,
  settings: state => state.settings,
  signedIn: state => state.signedIn,
  unverifiedUser: state => state.unverifiedUser,
  userIsAdmin: state => state.me?.role === 'admin',
  w9: state => state.w9,
}

const actions = {
  async loadBadges({ commit }) {
    const result = await api.get('/me/badges')
    if (result.ok) {
      commit('SET_BADGES', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadMe({ commit }) {
    const result = await api.get('/me')
    if (result.ok) {
      commit('SET_ME', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadW9({ commit }) {
    const result = await api.get('/me/w9s/most_recent')
    if (result.ok) {
      commit('SET_W9', await result.json())
      return { ok: true }
    }
    
    commit('SET_W9', null)
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateMyPassword( { commit }, payload ) {
    const result = await api.post('/me/password', { user: payload } )
    if (result.ok) {
      commit('SET_ME', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async resetPassword( { commit }, payload) {
    const result = await api.insecure_post('/me/reset_password', payload)
    if (result.ok) {
      commit('SET_ME', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async login({ commit, dispatch }, { id, password }) {
    const result = await api.insecure_post('/me/login', { id, password })
    if (result.ok) {
      commit('SET_ME', await result.json())
      dispatch('filters/clearPartnerFilters', null, { root: true })
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async logout({ commit }) {
    await api.post('/me/logout')
    commit('LOGOUT')
  },

  async loadSettings( { state, commit } ) {
    // you only need to load settings once in an app
    if (state.settings_loaded)
      return { ok: true }

    const result = await api.get('/me/settings')
    if (result.ok) {
      commit('SET_SETTINGS', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadRecoveryMethods( { commit }, { id } ) {
    const result = await api.insecure_post('/me/recovery_methods', { id })
    if (result.ok) {
      const methods = await result.json()
      commit('SET_RECOVERY_METHODS', methods)
      return { ok: true, methods }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async recoverByMethod( {}, { type, method_id } ) {
    const result = await api.insecure_post('/me/recovery_code', { type, method_id })
    if (result.ok) {
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async acceptAgreement({ commit }, { user_id, acceptance_token }) {
    const result = await api.insecure_post('/me/accept_terms', { user_id, acceptance_token })
    if (result.ok) {
      commit('SET_ME', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async createW9({ commit }, { name, street, city, state, zipcode, ssn, signature }) {
    const payload = {
      w9: { name, street, city, state, zipcode, ssn, signature },
    }
    const result = await api.post('/me/w9s', payload)
    if (result.ok) {
      commit('SET_W9', await result.json)
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  }
}

const mutations = { 
  SET_BADGES: (state, badges) => state.badges = badges,

  SET_ME (state, me) {
    state.signedIn = true
    state.me = me
  },

  SET_RECOVERY_METHODS: (state, methods) => state.recoveryMethods = methods,
  SET_SETTINGS(state, settings) {
    state.settings = settings
    state.settings_loaded = true
  },
  SET_UNVERIFIED_USER: (state, email) => state.unverifiedUser = email,
  SET_W9: (state, w9) => state.w9 = w9,

  LOGOUT(state) {
    state.signedIn = false
    state.me = defaultMe()
  },

  SET_ACCEPTANCE_KEYS (state, { user_id, acceptance_token }) {
    state.acceptanceKeys.user_id = user_id
    state.acceptanceKeys.acceptance_token = acceptance_token
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}